import Vue from 'vue'
import OECDRouter from './OECDRouter.js'
import routes from './routes.js'

Vue.use(OECDRouter)

const router = new OECDRouter({
  routes,
})

export default router
